<!--        sezioni colorate-->
<ng-container>
  <!--          tipologia riconoscimento-->
  <div class="row align-items-center p-2 mt-1 mb-2"
       [ngClass]="{'ml-2 border-left tertiary-border-color position-static':!minimizedReview}">
    <div class="col-12" *ngIf="!minimizedReview">
      <div
        class="row justify-content-start flex-nowrap text-truncate d-block tertiary-color font-weight-semibold">
        {{"RECOGNITION_TYPE" | translate | uppercase}}
      </div>
    </div>
    <div class="col-12" *ngIf="!minimizedReview">
      <div class="row justify-content-start flex-nowrap text-truncate d-block">
        <img
          src="ui-resources/{{data?.operation}}.png"
          class="img-fluid rounded pr-2" alt="{{data?.operation | translate}}"
          title="{{data?.operation | translate}}"
          style="height: 30px">
        {{data.operation | translate}}
      </div>
    </div>
    <div class="col-12" *ngIf="minimizedReview">
      <div class="row justify-content-start flex-nowrap text-truncate d-block">
        <img
          src="ui-resources/{{data?.operation}}.png"
          class="img-fluid rounded pr-2" alt="{{data?.operation | translate}}"
          title="{{data?.operation | translate}}"
          style="height: 30px">
      </div>
    </div>
  </div>
  <!--          tipo cliente-->
  <div class="row align-items-center p-2 mt-1 mb-2"
       [ngClass]="{'ml-2 border-left tertiary-border-color position-static':!minimizedReview}">
    <div class="col-12" *ngIf="!minimizedReview">
      <div
        class="row justify-content-start flex-nowrap text-truncate d-block tertiary-color font-weight-semibold">
        {{"CUSTOMER_TYPE" | translate | uppercase}}
      </div>
    </div>
    <div class="col-12" *ngIf="!minimizedReview">
      <div class="row justify-content-start flex-nowrap text-truncate d-block">
        <span>{{order?.userType | translate}}</span>
      </div>
    </div>
    <div class="col-12" *ngIf="minimizedReview">
      <img
        src="ui-resources/{{order?.userType}}.png"
        class="img-fluid rounded pr-2" alt="{{order?.userType | translate}}"
        title="{{order?.userType | translate}}"
        style="height: 30px">
    </div>
  </div>
  <!--          info soggetto servizio-->
  <ng-container *ngFor="let s of order?.subjects">
    <div class="row align-items-center p-2 mt-1 mb-2"
         [ngClass]="{'ml-2 border-left tertiary-border-color position-static':!minimizedReview}">
      <div class="col-12" *ngIf="!minimizedReview">
        <div
          class="row justify-content-start flex-nowrap text-truncate d-block tertiary-color font-weight-semibold">
          {{s?.role | translate | uppercase}}
        </div>
      </div>
      <div class="col-12" *ngIf="!minimizedReview">
        <div class="row justify-content-start flex-nowrap text-truncate d-block">
          <span>{{s?.name + ' ' + s?.surname}}</span>
        </div>
        <div class="row justify-content-start flex-nowrap text-truncate d-block">
          <span>{{s?.taxCode}}</span>
        </div>
        <ng-container *ngFor="let c of s?.contacts">
          <div class="row justify-content-start flex-nowrap text-truncate d-block">
            <span>{{c?.value}}</span>
          </div>
        </ng-container>
      </div>
      <div class="col-12" *ngIf="minimizedReview">
      </div>
    </div>
  </ng-container>
  <!--          configurazione prodotto-->
  <div class="row align-items-center p-2 mt-1 mb-2"
       [ngClass]="{'ml-2 border-left tertiary-border-color position-static':!minimizedReview}">
    <div class="col-12" *ngIf="!minimizedReview">
      <div
        class="row justify-content-start flex-nowrap text-truncate d-block tertiary-color font-weight-semibold">
        {{"PRODUCT_TYPE" | translate | uppercase}}
      </div>
    </div>
    <div class="col-12" *ngIf="!minimizedReview">
      <div class="row justify-content-start d-block">
        <img src="ui-resources/{{product?.productType?.article}}.png"
             class="img-fluid rounded pr-1" alt="{{product?.productType?.article}}"
             title="{{'ARTICLE_TYPES.' + product?.productType?.article | translate}}" style="height: 24px">
        {{'PRODUCT_TYPES.' + product.productType?.article + (product.productType?.type && product.productType?.type !== 'NONE' ? '_' + product.productType?.type : '') | translate}}
      </div>
    </div>
    <div class="col-12" *ngIf="minimizedReview">
      <img src="ui-resources/{{product?.productType?.article}}.png"
           class="img-fluid rounded pr-1" alt="{{product?.productType?.article}}"
           title="{{'ARTICLE_TYPES.' + product?.productType?.article | translate}}" style="height: 24px">
    </div>
  </div>
</ng-container>
